import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Loader } from '@citrus/loader';
import { Icon } from '@citrus/icon';
import { Layout, Header, SectionTitle } from '@citrus/layout';
import { PrimaryButton, SecondaryButton } from '@citrus/button';
import { Textfield } from '@citrus/input-textfield';
import { SelectStatic } from '@citrus/input-select';
import { VisualPicker } from '@citrus/input-visual-picker';
import { ZeroState } from '@citrus/zero-state';
import { Banner } from '@citrus/banner'
import FormEditor from './formEditor.container';
import CitrusFormViewer from "../Common/Components/citrusFormViewer/citrusFormViewer";
import { isNullOrEmptyString } from '../Common/Services/utilities';
import { Modal } from '@citrus/modal';
import { capitalize, isNotNullOrEmpty } from '@pcty/utils';
import * as scratch from '../../Images/scratch.svg';
import { TalentFormFormTypes } from '../formViewer/formViewer.constants';
import { getSurveyCategoryTypes } from './formEditor.constants';
import { isEscapedTextLengthGreaterThanMaxLength } from '../Common/Services/utilities';
import './formEditorWizard.less'

const FormTemplateSourceTypes = {
  DefaultTemplate: 0,
  CustomTemplate: 1,
};


class FormEditorWizard extends Component {

  constructor(props) {
    super(props);

    let formTypeId = parseInt(props.params.formTypeId || '0');

    this.state = {
      showFormEditor: false,
      templateSourceTypeId: FormTemplateSourceTypes.DefaultTemplate,
      selectedFormTemplateId: undefined,
      selectedFormTemplate: {},
      formTypeId: 0,
      headerLabel: '',
      descriptionLabel: '',
      isCategoryTypeRequired: (formTypeId === TalentFormFormTypes.Surveys),
      name: {
        value: props.formName,
        modified: false,
        validationState: {
          valid: !isNullOrEmptyString(props.formName),
          errorMessage: 'Name is required',
          showValidationState: false,
        },
      },
      categoryType: {
        selected: {
          value: '',
          label: ''
        },
        modified: false,
        validationState: {
          valid: !isNullOrEmptyString(props.selectedFormCategoryId),
          errorMessage: 'Category is required',
          showValidationState: false,
        },
      },
      changeTemplateModal: {
        newTemplateId: null,
        open: false
      }
    };
  }

  UNSAFE_componentWillMount() {
    let companyId = this.props.params.companyId;
    let employeeId = this.props.params.employeeId;
    let formId = this.props.params.formId;
    let formTypeId = parseInt(this.props.params.formTypeId || '0');
    let isCategoryTypeRequired = (formTypeId === TalentFormFormTypes.Surveys);

    if (formId && (parseInt(formId) > 0 || formId.length > 12) ) {
      this.setState({ formTypeId, isCategoryTypeRequired, templateSourceTypeId: FormTemplateSourceTypes.CustomTemplate, showFormEditor: true });
    }
    else {
      if (this.props.defaultTemplates.length === 0) {
        this.props.loadDefaultFormTemplates(companyId, employeeId, formTypeId);
      }
    }
  }

  componentDidMount() {
    let formTypeId = parseInt(this.props.params.formTypeId || '0');
    let useSurveyLabels = this.isOptionEnabled("useSurveyLabels") || parseInt(formTypeId) === TalentFormFormTypes.Surveys;
    let headerLabel = useSurveyLabels ? "Create Survey" : "Create Form";
    let descriptionLabel = useSurveyLabels ? "survey" : "form";
    let isCategoryTypeRequired = (formTypeId === TalentFormFormTypes.Surveys);

    if (this.props.options && this.props.options.bypassTemplateSelection) {
      this.setState({showFormEditor: true})
    }

    this.setState({ formTypeId, headerLabel, descriptionLabel, isCategoryTypeRequired });
  }

  onTemplateSourceTypeChange(e) {
    const selectedIndex = e.selectedIndexes[0];
    if (selectedIndex < 0 || selectedIndex === this.state.templateSourceTypeId) return;  // toggle the value, don't allow deselect!

    const name = {
      value: '',
      modified: false,
      validationState: {
        valid: false,
        errorMessage: 'Name is required',
        showValidationState: false,
      },
    };

    const categoryType = {
      selected: {
        value: '',
        label: ''
      },
      modified: false,
      validationState: {
        valid: false,
        errorMessage: 'Category is required',
        showValidationState: false,
      },
    };

    this.setState({ name, categoryType, templateSourceTypeId: selectedIndex, selectedFormTemplate: {}, selectedFormTemplateId: undefined });
  }

  onCancelChangeTemplate() {
    const changeTemplateModal = { newTemplateId: null,  open: false};
    this.setState({changeTemplateModal});
  }

  onSelectedTemplateChange(e) {
    const newTemplateId = (e && e.value && e.value.length > 0) ? e.value : null;
    if (!newTemplateId) return;

    // if the user is selecting the first one or they didn't modify it, skip the confirmation
    if (!this.state.selectedFormTemplateId) {
      this.onClickConfirmChangeTemplate(newTemplateId);
    }
    else if (this.state.selectedFormTemplateId && !this.state.name.modified && !this.state.categoryType.modified) {
      this.onClickConfirmChangeTemplate(newTemplateId);
    }
    else {
      const changeTemplateModal = { newTemplateId,  open: true};
      this.setState({changeTemplateModal});
    }
  }

  onClickConfirmChangeTemplate(newTemplateId) {
    let template = {};

    if (newTemplateId) {
      template = this.props.defaultTemplates.filter(x => {
        return x.id === parseInt(newTemplateId);
      })[0];
    }

    const name = {
      value: `Copy of ${template.templateName}`,
      modified: false,
      validationState: {
        valid: !isNullOrEmptyString(template.templateName),
        errorMessage: 'Name is required',
        showValidationState: true,
      },
    };

    const formCategoryTypes = (this.state.formTypeId === TalentFormFormTypes.Surveys ? getSurveyCategoryTypes() : []).map(x => ({ value: x.id, label: x.label }));
    const templateCategoryType = template.formCategoryTypeId ? formCategoryTypes.filter(x => x.value === template.formCategoryTypeId.toString()) : null;
    const categoryType = {
      selected: templateCategoryType && templateCategoryType.length > 0 ? templateCategoryType[0] : {value: '', label: ''},
      validationState: {
        valid: !isNullOrEmptyString(template.formCategoryTypeId),
        errorMessage: 'Category is required',
        showValidationState: true,
      },
    };

    const changeTemplateModal = { newTemplateId: null,  open: false};
    this.setState({ name, categoryType, changeTemplateModal, selectedFormTemplate: template, selectedFormTemplateId: newTemplateId });
  }

  handleBackClick() {
    var evt = new CustomEvent('PctyTalentFormEditorGoBack', { detail: this.props.params });
    window.dispatchEvent(evt);
  }

  handleNextClick() {
    const name = {...this.state.name,
      validationState: {
        valid: !isNullOrEmptyString(this.state.name.value),
        errorMessage: 'Name is required',
        showValidationState: true,
      },
    }

    const categoryType = {...this.state.categoryType,
      validationState: {
        valid: !isNullOrEmptyString(this.state.categoryType.selected.value),
        errorMessage: 'Category is required',
        showValidationState: true,
      },
    }

    const formValid = this.state.isCategoryTypeRequired ? name.validationState.valid && categoryType.validationState.valid : name.validationState.valid;
    this.setState({ name, categoryType, showFormEditor: formValid });
  }

  isUserSelectionValid() {
    let valid = (this.state.templateSourceTypeId === FormTemplateSourceTypes.CustomTemplate || this.state.selectedFormTemplateId);
    return valid;
  }

  isOptionEnabled(option) {
    let enabled = (this.props.options && this.props.options[option] === true) ? true : false;
    return enabled;
  }

  renderChangeTemplateConfirmationModal() {
    return (<Modal
      headerText="Change Template?"
      id="change-template-modal"
      onCancel={this.onCancelChangeTemplate}
      open={this.state.changeTemplateModal.open}
      size="small">
      <p>Changing templates will reset any data entered. Are you sure you want to continue?</p>
      <Modal.Footer>
        <PrimaryButton onClick={() => this.onClickConfirmChangeTemplate(this.state.changeTemplateModal.newTemplateId)}>Yes</PrimaryButton>
        <SecondaryButton data-dismiss="modal" onClick={() => this.onCancelChangeTemplate()}>No</SecondaryButton>
      </Modal.Footer>
    </Modal>);
  }

  handleOnChangeName(e) {
    const name = {
      value: e.value,
      modified: true,
      validationState: {
        ...this.state.name.validationState,
        valid: isNotNullOrEmpty(e.value),
        showValidationState: true,
      },
    };

    this.setState({ name });
  }

  handleOnChangeCategoryType(selected, id) {
    const valid = this.state.isCategoryTypeRequired ? isNotNullOrEmpty(selected.value) : true;

    const categoryType = {
      selected,
      modified: true,
      validationState: {
        ...this.state.categoryType.validationState,
        valid: valid,
        showValidationState: true,
      },
    };

    this.setState({ categoryType });
  }

  renderTemplateTypeSelection() {
    const zeroStateMessage = this.state.templateSourceTypeId
      ? 'You will start from scratch.'
      : `No template selected. Pick one from the dropdown list to preview it and start creating your ${this.state.descriptionLabel} from a template.`;
    const zeroStateImage = this.state.templateSourceTypeId ? scratch : null;
    const templates = this.props.defaultTemplates.map(item => {
      return { value: item.id.toString(), label: item.templateName };
    });

    //let useSurveyLabels = this.isOptionEnabled("useSurveyLabels") || this.state.formTypeId === TalentFormFormTypes.Surveys;
    const showFormCategories = this.isOptionEnabled('showFormCategories') || this.state.formTypeId === TalentFormFormTypes.Surveys;
    const formCategoryTypes = this.state.formTypeId === TalentFormFormTypes.Surveys ? getSurveyCategoryTypes() : [];
    const selectedTemplate = this.state.selectedFormTemplateId ? templates.find(x => x.value === this.state.selectedFormTemplateId) : null;
    const showFormDetails = this.state.templateSourceTypeId === FormTemplateSourceTypes.CustomTemplate || selectedTemplate;

    const renderTypeOptions = () => {
      const validationState = this.state.categoryType.validationState;
      const classes = !validationState.valid && validationState.showValidationState ? "render-type-options pcty-error" : "render-type-options"

      if (isNotNullOrEmpty(formCategoryTypes)) {
        const options = formCategoryTypes.map(x => ({ value: x.id, label: x.label }));
        //const selectedValue = options.find(x => x.value === this.state.categoryType.selected);
        return (
          <SelectStatic
            automationId={AutomationIds.selectCategoryType}
            id={`select-category-type`}
            className={classes}
            label={`${capitalize(this.state.descriptionLabel)} Category`}
            onChange={(id, selected) => this.handleOnChangeCategoryType(id, selected)}
            options={options}
            required={this.state.isCategoryTypeRequired}
            placeholder="Select..."
            errorMessage={this.state.categoryType.validationState.errorMessage}
            showValidationState={this.state.categoryType.validationState.showValidationState}
            valid={this.state.categoryType.validationState.valid}
            value={this.state.categoryType.selected} />
        );
      }
    }

    const renderActionArea = () => <React.Fragment>
        <PrimaryButton
          automationId={AutomationIds.launchHeaderNextButton}
          disabled={!this.isUserSelectionValid()}
          onClick={() => this.handleNextClick()}>Next</PrimaryButton>
      </React.Fragment>;
    const renderHeader = () => <Header automationId={AutomationIds.talentFormsV2Header} renderActionArea={renderActionArea} title={this.state.headerLabel} onBack={() => this.handleBackClick()} />;

    const renderNameAndCategory = () => {
      return (showFormDetails && <div className="pcty-row pcty-margin-bottom">
        <div className="pcty-col-xs-6">
          <Textfield
            automationId={AutomationIds.talentFormsV2CreatFormName}
            id={`create-form-name`}
            label={`${capitalize(this.state.descriptionLabel)} Name`}
            maxLength={255}
            onChange={(id, value) => this.handleOnChangeName(id, value)}
            placeholder={`Please enter a ${this.state.descriptionLabel} name`}
            required={true}
            errorMessage={this.state.name.validationState.errorMessage}
            showValidationState={this.state.name.validationState.showValidationState}
            valid={this.state.name.validationState.valid}
            value={this.state.name.value} />
        </div>
        <div className="pcty-col-xs-6">
          {showFormCategories && renderTypeOptions()}
        </div>
      </div>);
      };
    
    var isTitleTooLong = isEscapedTextLengthGreaterThanMaxLength(this.state.name.value, 100)

    const flattenedQuestions = this.state.questions ? this.state.questions.flat() : [];
    return (!this.state.showFormEditor &&
        <Layout renderHeader={renderHeader}>
        {this.renderChangeTemplateConfirmationModal()}
        {isTitleTooLong ? <Banner id="name-too-long-warning-banner" automationId={AutomationIds.nameTooLongWarningBanner} type="warning" spacing={["right", "bottom"]} css={ {marginRight: "0px"} }>Template name is too long and will be truncated to 100 characters. Symbols may count as more than one character, affecting the 100-character limit.</Banner> : <></>}

        <div className="pcty-row form-editor-wizard-container" style={{ marginTop: '-15px', minHeight: '500px' }}>
          <div className="pcty-col-xs-12 pcty-margin-top">
            <Loader loading={this.props.isLoading} global={true} />

            <div className="pcty-row pcty-margin-bottom">
              <div className="pcty-col-xs-12 template-source-types" >
                <VisualPicker
                  automationId={AutomationIds.talentFormsV2FormEditorWizardSelection}
                  id="form-editor-wizard-selection"
                  maxColumns={2}
                  type={'single'}
                  onChange={(e) => this.onTemplateSourceTypeChange(e)}
                  selectedIndexes={[this.state.templateSourceTypeId]}
                  css={{justifyContent: "space-between"}}>
                    <VisualPicker.Item
                      automationId={AutomationIds.talentFormsV2FromTemplateButton}
                      label="Start from a template"
                      renderIcon={() => <Icon name="file-text" title="Start from a template" />}
                      value={FormTemplateSourceTypes.DefaultTemplate.toString()} />
                    <VisualPicker.Item
                      automationId={AutomationIds.talentFormsV2FromScratchButton}
                      label="Start from scratch"
                      renderIcon={() => <Icon name="file" title="Start from scratch" />}
                      value={FormTemplateSourceTypes.CustomTemplate.toString()} />
                  </VisualPicker>
              </div>
            </div>

            { (this.state.templateSourceTypeId === FormTemplateSourceTypes.DefaultTemplate)
              ?
              <React.Fragment>
                <div className="pcty-row">
                  <div className="pcty-col-xs-12">
                    <SectionTitle automationId={AutomationIds.talentFormsV2ChooseTemplateSectionTitle}>Choose Template</SectionTitle>
                  </div>
                </div>

                <div className="pcty-row pcty-margin-bottom">
                  <div className="pcty-col-xs-6">
                    <SelectStatic
                      automationId={AutomationIds.defaultTemplatesSelect}
                      className="default-templates-select"
                      id="defaultTemplates"
                      disabled={this.state.templateSourceTypeId !== FormTemplateSourceTypes.DefaultTemplate}
                      onChange={(id, item) => this.onSelectedTemplateChange(id, item.value, item.label)}
                      options={templates}
                      label={"Template"}
                      placeholder="Select Template..."
                      value={selectedTemplate} />
                  </div>
                </div>

                <div className="pcty-row pcty-margin-bottom">
                  <div className="pcty-col-xs-12">
                    {renderNameAndCategory()}
                  </div>
                </div>

                {this.state.selectedFormTemplateId &&
                  <React.Fragment>
                    <h2 className="preview-section-header">Preview</h2>

                    <div className="pcty-row">
                      <div className="pcty-col-xs-12 pcty-margin-top pcty-padding-bottom" style={{marginLeft: '-30px'}}>
                        <CitrusFormViewer
                          displayMode={'preview'}
                          formName={this.state.selectedFormTemplate.templateName}
                          configuration={this.state.selectedFormTemplate.configuration}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                }
              </React.Fragment>
              :
              <React.Fragment>
                <div className="pcty-row pcty-margin-bottom">
                  <div className="pcty-col-xs-12">
                    <SectionTitle automationId={AutomationIds.talentFormsV2EnterDetailsSectionTitle}>Enter Details</SectionTitle>
                    {renderNameAndCategory()}
                  </div>
                </div>
              </React.Fragment>
            }
            {!this.state.selectedFormTemplateId &&
              <div style={{ marginTop: '100px' }}>
                <ZeroState type="takeaction" message={zeroStateMessage} imageUrl={zeroStateImage}/>
              </div>
            }
      </div>
        </div>
      </Layout>
    );
  }

  renderFormEditor() {
    let params = this.props.params;
    if (this.state.templateSourceTypeId === FormTemplateSourceTypes.DefaultTemplate && this.state.selectedFormTemplateId) {
      params = {
        companyId: this.props.params.companyId,
        employeeId: this.props.params.employeeId,
        formId: this.state.selectedFormTemplateId.toString(),
        formTypeId: this.props.params.formTypeId,
        createdByName: this.props.params.createdByName,
        action: 'copy',
      };
    }

    params.wizardFormName = this.state.name.value;
    params.wizardFormCategoryType = this.state.categoryType.selected;

    return (this.state.showFormEditor &&
      <FormEditor params={params} options={this.props.options} />
    );
  }

  render() {
    return (
      <div className="bounding-box width-1280">
        {this.renderTemplateTypeSelection()}
        {this.renderFormEditor()}
      </div>
    );
  }

}

FormEditorWizard.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  params: PropTypes.object.isRequired,
  loadDefaultFormTemplates: PropTypes.func.isRequired,
  defaultTemplates: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export const AutomationIds = {  
  nameTooLongWarningBanner: "name-too-long-warning-banner",
  selectCategoryType: "select-category-type",
  launchHeaderNextButton: "launch-header-next-button",
  talentFormsV2Header: "talent-forms-v2-header",
  talentFormsV2CreatFormName: "talent-forms-v2-create-form-name",
  talentFormsV2FormEditorWizardSelection: "talent-forms-v2-form-editor-wizard-selection",
  talentFormsV2FromTemplateButton: "talent-forms-v2-from-template-button",
  talentFormsV2FromScratchButton: "talent-forms-v2-from-scratch-button",
  talentFormsV2ChooseTemplateSectionTitle: "talent-forms-v2-choose-template-section-title",
  defaultTemplatesSelect: "default-templates-select",
  talentFormsV2EnterDetailsSectionTitle: "talent-forms-v2-enter-details-section-title",
}

export default FormEditorWizard;
